import FirebaseAdapter from "@wc/adapters/firebase";

/**
 * Creates a new team via the createTeam callable function
 * The function handles adding the creator as TEAM_ADMIN and updating claims
 * @param {object} teamInfo Team information
 * @param {string} teamInfo.name The team name
 * @param {string} teamInfo.organizationId The organization this team belongs to
 * @param {object} _user The user creating the team
 * @param {string} _user.id The user's id
 * @returns {Promise<string>} The created team id
 */
export async function createTeam({ name, organizationId }, _user) {
  const result = await FirebaseAdapter().functions.createTeam({
    name,
    organizationId,
  });

  return result.teamId;
}
